module.exports = __webpack_public_path__ + "static/img/icon-eat-type-1.fc78e373.png";